export default __webpack_public_path__ + "static/media/chess.68a20dac.png";